import { Component, Input, OnInit } from '@angular/core';
import { ReponseCoordonneesCredit } from '../../../api/model/reponse-coordonnees-credit.model';
import { CybermetrieEnum } from '../../../models/cybermetrie/cybermetrie.enum';
import { CybermetrieCoordonneesService } from '../../../services/cybermetrie/cybermetrie.service';

@Component({
  selector: 'app-avertissement-modification-plusieurs-courriels-credit',
  templateUrl: './avertissement-modification-plusieurs-courriels-credit.component.html',
  styleUrls: ['./avertissement-modification-plusieurs-courriels-credit.component.scss'],
  standalone: false,
})
export class AvertissementModificationPlusieursCourrielsCreditComponent implements OnInit {
  @Input() reponseCoordonneesCredit!: ReponseCoordonneesCredit;

  constructor(private readonly cybermetrieService: CybermetrieCoordonneesService) {}

  ngOnInit(): void {
    this.cybermetrieService.envoyerEvenementPersonnalise(
      CybermetrieEnum.CATEGORIE_GESTION_CARTE,
      CybermetrieEnum.ACTION_AFFICHAGE,
      CybermetrieEnum.LABEL_PLUSIEURS_COURRIELS
    );
  }
}
